import React, { useEffect, useState } from 'react'
import logo from '../../images/logo.svg'
import { useNavigate } from 'react-router-dom'
import welcome from '../../images/welcome.svg'

function Confirmation() {
  const navigate = useNavigate()
  const [showCreateBtn, setShowCreateBtn] = useState(false)

  useEffect(() => {
    sessionStorage.setItem('choose-a-plan',1)
    const agencyId = sessionStorage.getItem('agency_id')
    const subscription = Number(sessionStorage.getItem('chgamsSubscription'))
    const organizations = Number(sessionStorage.getItem('organizations'))
    const dashboardRoute = sessionStorage.getItem('dashboardroute')
    const settingsUrl = sessionStorage.getItem('settingsUrl')

    if (!agencyId) {
      // agency_id not defined → redirect to dashboard
      //navigate(dashboardRoute || '/')
      return
    }

    if (subscription > 1) {
      if (organizations && organizations > 0) {
        // subscription ok + organizations exist → redirect to dashboard
        //navigate(dashboardRoute || '/')
      }
    } else {
      // subscription < 2 or null/undefined → show create subscription button
      setShowCreateBtn(true)
    }
  }, [navigate])

  const handleCreateSubscription = () => {
    const settingsUrl = sessionStorage.getItem('settingsUrl')
    if (settingsUrl) {
      window.location.href = settingsUrl
    }
  }

  return (
    <div className='grid grid-cols-2'>
      <div className='col-span-2 lg:col-span-1 px-5 lg:px-20 flex flex-col space-y-20 lg:space-y-40 pt-5'>
        <span><img src={logo} alt="logo" /></span>
        <div className='flex flex-col space-y-8 text-start'>
          <div className='flex flex-col space-y-2'>
            <span className='text-[#090712] text-[32px] font-[500]'>Welcome Back Agent!</span>
            <span className='text-[#828282] text-[16px] font-[400]'>
              Please proceed to choose a plan so you can start adding your Charities right away!
            </span>
          </div>

          
            <div className='pt-5'>
              <button
                onClick={handleCreateSubscription}
                className='bg-[#B30000] text-white w-full h-[50px] rounded-[4px]'
              >
                Create Subscription
              </button>
            </div>
    
        </div>
      </div>

      <div className='col-span-1 pl-5 hidden lg:flex lg:pl-20 bg-[#F3F5F7] flex flex-col text-start pt-20'>
        <span className='text-[40px] font-[600]'>Welcome to Chgams</span>
        <span className='text-[#4F4F4F] pr-5'>
          We help empower charity organizations to efficiently register and manage all activities of their members.
        </span>
        <div className='ml-[-40px]'><img src={welcome} alt="welcome" /></div>
      </div>
    </div>
  )
}

export default Confirmation
